import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import ApproachableAI from "./ApproachableAI";
import DataQaAnalysis from "./DataQaAnalysis";

const QualityAnalysis = ({ features }) => {
  const CLIENT_ROUTES = {
    "Data Quality Analysis": {
      component: DataQaAnalysis,
      path: "data-qa-analysis",
    },
    "Approachable AI": {
      component: ApproachableAI,
      path: "approachable-ai/*",
    },
    "Specific Approachable AI": {
      component: ApproachableAI,
      path: ":datasetName/approachable-ai/*",
    },
  };

  return (
    <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
  );
};

export default QualityAnalysis;
